import { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';

import { useAuth } from './store/auth';
import { Spinner } from './components/ui';

import Login from './routes/Login';
import Register from './routes/Register';
import Dashboard from './routes/Dashboard';
import Fleet from './routes/Fleet';
import AssetDetail from './routes/AssetDetail';
import AssetForm from './routes/AssetForm';
import Customers from './routes/Customers';
import CustomerForm from './routes/CustomerForm';
import InspectionRun from './routes/InspectionRun';
import InspectionView from './routes/InspectionView';
import Inspections from './routes/Inspections';
import Planner from './routes/Planner';
import Jobs from './routes/Jobs';
import JobForm from './routes/JobForm';
import Invoices from './routes/Invoices';
import InvoiceView from './routes/InvoiceView';
import Defects from './routes/Defects';
import More from './routes/More';
import Settings from './routes/Settings';
import Reminders from './routes/Reminders';
import Staff from './routes/Staff';

export default function App() {
  const status = useAuth((s) => s.status);
  const restore = useAuth((s) => s.restore);
  const { pathname } = useLocation();

  useEffect(() => {
    restore();
  }, [restore]);

  // Every navigation starts at the top of the new screen.
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  if (status === 'loading') {
    return (
      <div style={{ minHeight: '100dvh', display: 'grid', placeItems: 'center' }}>
        <Spinner label="Signing in" />
      </div>
    );
  }

  if (status === 'signed-out') {
    return (
      <Routes>
        <Route path="/register" element={<Register />} />
        <Route path="*" element={<Login />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<Dashboard />} />

      <Route path="/fleet" element={<Fleet />} />
      <Route path="/fleet/new" element={<AssetForm />} />
      <Route path="/fleet/:id" element={<AssetDetail />} />
      <Route path="/fleet/:id/edit" element={<AssetForm />} />

      <Route path="/customers" element={<Customers />} />
      <Route path="/customers/new" element={<CustomerForm />} />
      <Route path="/customers/:id" element={<CustomerForm />} />

      <Route path="/inspections" element={<Inspections />} />
      <Route path="/inspections/:id" element={<InspectionView />} />
      <Route path="/inspections/:id/run" element={<InspectionRun />} />

      <Route path="/planner" element={<Planner />} />
      <Route path="/defects" element={<Defects />} />

      <Route path="/jobs" element={<Jobs />} />
      <Route path="/jobs/new" element={<JobForm />} />
      <Route path="/jobs/:id" element={<JobForm />} />

      <Route path="/invoices" element={<Invoices />} />
      <Route path="/invoices/:id" element={<InvoiceView />} />

      <Route path="/more" element={<More />} />
      <Route path="/reminders" element={<Reminders />} />
      <Route path="/settings" element={<Settings />} />
      <Route path="/staff" element={<Staff />} />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
